export default {
	'no-materials-to-show': 'NO MATERIALS TO SHOW',
	'tab-products': 'Products',
	'tab-received-samples': 'Received Samples',
	'tab-unreceived-samples': 'Unreceived Samples',
	'stock-quantities': 'Stock Quantities',
	'sample-name': 'Item Name',
	remaining: 'Remaining',
	'no-samples-to-show': 'NO ITEMS TO SHOW',
	'sort-by': 'Sort by',
	'no-unreceived-samples-to-show': 'NO ITEMS TO SHOW',
	accept: 'Accept',
	'unreceived-sample-accepted': 'Material received successfully',
	warehouse: 'Warehouse'
}
